import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Form, Grid, Header, Segment } from "semantic-ui-react";

import { getPermissions, getUsers } from "../../reducer";
import { loadPermissions, loadUsers, saveUser } from "../../reducer/actions";
import { getTranslate } from "react-localize-redux";

class Sites extends Component {


    constructor(props) {
        super(props);
        this.state = {
            email: '',
            name: '',
            password: '',
            warehouses: [],
            permissions: []
        }
    }

    componentDidMount() {
        this.props.loadUsers().then((users) => {
            this.prepareUser()
        });
    }

    componentWillMount() {
        this.props.loadPermissions();
    }

    getPermissionOptions() {
        return this.props.permissions.map((permission) => {
            return {
                key: permission.name,
                text: permission.displayName,
                value: permission.id
            };
        });
    }

    prepareUser() {
        let user = this.findUser(this.props.match.params.id);
        if (user === null || typeof user === 'undefined') {
            return false;
        }
        user.permissions = user.permissions.map((permission) => (permission.id));
        this.setState({...user});
    }


    findUser(id) {
        for (let i in this.props.users) {
            if (parseInt(this.props.users[i].id,10) === parseInt(id,10)) {
                return this.props.users[i];
            }
        }
        return null;
    }

    render() {
        return (

                    <Segment style={{padding: '8em 0em'}} vertical>
                        <Grid container stackable verticalAlign='middle' centered>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <Header as='h2' color='teal' textAlign='center'>
                                        {this.props.translate('admin.user.edit.header')}
                                    </Header>
                                    <Form size='large' onSubmit={() => {
                                        this.props.saveUser(this.state)
                                    }}>
                                        <Segment stacked>
                                            <Form.Input
                                                label={this.props.translate('general.email')}
                                                fluid
                                                icon='mail outline'
                                                iconPosition='left'
                                                placeholder={this.props.translate('general.email')}
                                                type={'email'}
                                                value={this.state.email}
                                                onChange={(e) => {
                                                    this.setState({email: e.target.value})
                                                }}
                                            />
                                            <Form.Input
                                                label={this.props.translate('general.name')}
                                                fluid
                                                icon='user'
                                                iconPosition='left'
                                                placeholder={this.props.translate('general.name')}
                                                type={'text'}
                                                value={this.state.name}
                                                onChange={(e) => {
                                                    this.setState({name: e.target.value})
                                                }}
                                            />
                                            <Form.Input
                                                label={this.props.translate('general.password')}
                                                fluid
                                                icon='lock'
                                                iconPosition='left'
                                                placeholder={this.props.translate('general.password')}
                                                type={'password'}
                                                value={this.state.password}
                                                onChange={(e) => {
                                                    this.setState({password: e.target.value})
                                                }}
                                            />

                                            <Form.Dropdown placeholder={this.props.translate('general.permissions')} fluid multiple selection
                                                           label={this.props.translate('general.permissions')}
                                                           options={this.getPermissionOptions()}
                                                           value={this.state.permissions} onChange={(e, {value}) => {
                                                this.setState({permissions: value})
                                            }}/>

                                            <Button type='submit'>{this.props.translate('general.save')}</Button>
                                        </Segment>
                                    </Form>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Segment>
        );
    }

}


const mapStateToProps = state => {
    return {
        users: getUsers(state.admin),
        translate: getTranslate(state.localize),
        permissions: getPermissions(state.admin)

    }
};

const mapDispatchToProps = (dispatch) => {
    return ({
        loadUsers: () => {
            return dispatch(loadUsers())
        },
        saveUser: (user) => {
            return dispatch(saveUser(user))
        },
        loadPermissions: () => {
            return dispatch(loadPermissions());
        }
    });
};


function mergeProps(stateProps, dispatchProps, ownProps) {
    return {

        ...stateProps,
        ...ownProps,
        ...dispatchProps,

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(Sites)



// WEBPACK FOOTER //
// ./src/scenes/Admin/scenes/UserDetail/index.js